import React from 'react';

const AssistantClarificationChoices = ({ options, disabled, onSelect }) => {
  if (!Array.isArray(options) || !options.length) {
    return null;
  }

  return (
    <div className='d-flex flex-wrap mt-2'>
      {options.map((option, optionIndex) => (
        <button
          key={optionIndex}
          type='button'
          className='btn btn-sm btn-light-primary mr-2 mb-2 text-left'
          disabled={disabled}
          onClick={() => onSelect(option, optionIndex + 1)}
        >
          {option}
        </button>
      ))}
    </div>
  );
};

export default AssistantClarificationChoices;
